var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210.26 210.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #f27800;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.99,
    y: 25.99,
    width: 158.28,
    height: 158.28,
    rx: 23.28,
    ry: 23.28,
    transform: "translate(105.13 -43.55) rotate(45)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m128.44,118.37c-4.7,7.93-13.49,13.14-23.47,12.73-13.17-.54-24.04-11.16-24.85-24.32-.94-15.11,11.04-27.66,25.95-27.66,9.47,0,17.75,5.06,22.29,12.62.25.41.68.67,1.17.67h27.44c.89,0,1.56-.85,1.33-1.71-6.5-23.59-28.54-40.74-54.43-39.71-28.02,1.11-50.8,23.89-51.92,51.91-1.24,30.93,23.47,56.4,54.13,56.4,24.98,0,45.99-16.91,52.26-39.9.23-.86-.43-1.71-1.32-1.71h-27.39c-.49,0-.93.26-1.17.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinify);
export default __webpack_public_path__ + "static/media/coinify.88440784a5cc02481646ebe5dd059597.svg";
export { ForwardRef as ReactComponent };